var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('SectionBanner'),_vm._v(" "),_c('SectionInvite'),_vm._v(" "),_c('SectionSolution'),_vm._v(" "),_c('SectionFlow'),_vm._v(" "),_c('SectionTec'),_vm._v(" "),_c('SectionSuccess')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }